
      Diese Applikation ist Teil der Ausstellung
      <a href="https://schule-zukunft.ch" target="_blank"
        >schule-zukunft.ch <mat-icon svgIcon="external-link"></mat-icon></a>
    